










import { Component, Vue } from 'vue-property-decorator';
import UiButton from '@/components/ui/buttons/Button.vue';
import ShapeDiagonalBottomLeft from '@/components/ui/shapes/ShapeDiagonalBottomLeft.vue';

@Component({
  components: {
    UiButton,
    ShapeDiagonalBottomLeft,
  },
})
export default class Contact extends Vue {}
